import _toConsumableArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// Copyright 2017-2021 @polkadot/api authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { logger } from '@polkadot/util';
var l = logger('api/augment');

function logLength(type, values) {
  var and = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return values.length ? " ".concat(values.length, " ").concat(type).concat(and.length ? ' and' : '') : '';
}

function logValues(type, values) {
  return values.length ? "\n\t".concat(type.padStart(7), ": ").concat(values.sort().join(', ')) : '';
} // log details to console


function warn(prefix, type, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      added = _ref2[0],
      removed = _ref2[1];

  if (added.length || removed.length) {
    l.warn("api.".concat(prefix, ": Found").concat(logLength('added', added, removed)).concat(logLength('removed', removed), " ").concat(type, ":").concat(logValues('added', added)).concat(logValues('removed', removed)));
  }
}

function extractKeys(src, dst) {
  return [Object.keys(src), Object.keys(dst)];
}

function findSectionExcludes(a, b) {
  return a.filter(function (section) {
    return !b.includes(section);
  });
}

function extractSections(src, dst) {
  var _extractKeys = extractKeys(src, dst),
      _extractKeys2 = _slicedToArray(_extractKeys, 2),
      srcSections = _extractKeys2[0],
      dstSections = _extractKeys2[1];

  return [findSectionExcludes(srcSections, dstSections), findSectionExcludes(dstSections, srcSections)];
}

function findMethodExcludes(src, dst) {
  var srcSections = Object.keys(src);
  var dstSections = Object.keys(dst);
  return dstSections.filter(function (section) {
    return srcSections.includes(section);
  }).reduce(function (rmMethods, section) {
    var srcMethods = Object.keys(src[section]);
    return rmMethods.concat.apply(rmMethods, _toConsumableArray(Object.keys(dst[section]).filter(function (method) {
      return !srcMethods.includes(method);
    }).map(function (method) {
      return "".concat(section, ".").concat(method);
    })));
  }, []);
}

function extractMethods(src, dst) {
  return [findMethodExcludes(dst, src), findMethodExcludes(src, dst)];
}
/**
 * Takes a decorated api section (e.g. api.tx) and augment it with the details. It does not override what is
 * already available, but rather just adds new missing ites into the result object.
 * @internal
 */


export function augmentObject(prefix, src, dst) {
  var fromEmpty = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (fromEmpty) {
    Object.keys(dst).forEach(function (key) {
      delete dst[key];
    });
  }

  if (prefix && Object.keys(dst).length) {
    warn(prefix, 'modules', extractSections(src, dst));
    warn(prefix, 'calls', extractMethods(src, dst));
  }

  return Object.keys(src).reduce(function (newSection, sectionName) {
    var section = src[sectionName];
    newSection[sectionName] = Object.keys(section).reduce(function (result, methodName) {
      // TODO When it does match, check the actual details and warn when there are differences
      if (!result[methodName]) {
        result[methodName] = section[methodName];
      }

      return result;
    }, dst[sectionName] || {});
    return newSection;
  }, dst);
}